import { graphql } from '@/gql'

export const DASHBOARD_VIEWS = graphql(`
  query dashboardViews($filter: DashboardViewFilter) {
    dashboardViews(
      filter: $filter
      orderBy: NAME_ASC
      condition: { active: true }
    ) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`)

export const CALENDAR_BIRTHDAY_ANNIVERSARY_QUERY = graphql(`
  query calendarBirthdayAnniversary($filter: UserFilter) {
    users(includeArchived: NO, filter: $filter) {
      nodes {
        id
        fullName
        birthdate
        seniority
        logo
        employeeId
      }
    }
  }
`)

export const CALENDAR_EMPLOYMENT_START_END_QUERY = graphql(`
  query calendarEmploymentStartEnd($filter: UserFilter) {
    users(condition: { active: true }, filter: $filter) {
      nodes {
        id
        fullName
        birthdate
        employmentStart
        employmentEnd
        logo
        employeeId
      }
    }
  }
`)

export const DASHBOARD_CARDS = graphql(`
  query dashboardCards($dashboardViewId: UUID!) {
    dashboardCards(
      filter: {
        active: { equalTo: true }
        dashboardViewId: { equalTo: $dashboardViewId }
        or: [
          {
            type: { notEqualTo: CUSTOM_WIDGET }
            customWidgetId: { isNull: true }
          }
          {
            type: { equalTo: CUSTOM_WIDGET }
            customWidget: { active: { equalTo: true } }
          }
        ]
      }
      orderBy: ORDER_ASC
    ) {
      nodes {
        id
        type
        departmentIds
        jobPositionTypeIds
        customWidget {
          id
          useImage
          widgetSize
          backgroundColor
          widgetTextColor
          buttonTextColor
          buttonBackgroundColor
          buttonBorder
          imageLayout
          image {
            id
            url
          }
          customWidgetContents(filter: { active: { equalTo: true } }) {
            nodes {
              id
              locale
              title
              content
              addButton
              buttonText
              buttonLink
              isInternalButtonLink
            }
          }
        }
        dashboardCardStatistics(
          filter: { active: { equalTo: true } }
          orderBy: ORDER_ASC
        ) {
          nodes {
            id
            chartType
            formField {
              id
              active
              localizedName
              formFieldOptions(filter: { active: { equalTo: true } }) {
                nodes {
                  id
                  localizedValue
                }
              }
            }
            systemField {
              id
              name
            }
          }
        }
      }
    }
  }
`)

export const DASHBOARD_VIEW = graphql(`
  query dashboardViewById($id: UUID!) {
    dashboardViewById(id: $id) {
      id
      name
    }
  }
`)

export const DASHBOARD_CARD = graphql(`
  query dashboardCardById($id: UUID!) {
    dashboardCardById(id: $id) {
      id
      type
      departmentIds
      jobPositionTypeIds
      dashboardCardStatistics(
        filter: { active: { equalTo: true } }
        orderBy: ORDER_ASC
      ) {
        nodes {
          id
          chartType
          formField {
            id
            localizedName
            formFieldOptions(filter: { active: { equalTo: true } }) {
              nodes {
                id
                localizedValue
              }
            }
          }
          systemField {
            id
            name
          }
        }
      }
    }
  }
`)

export const AVERAGE_AGE = graphql(`
  query averageAge($departmentIds: [UUID]) {
    averageAge(argDepartmentIds: $departmentIds)
  }
`)

export const AVERAGE_SENIORITY = graphql(`
  query averageSeniority($departmentIds: [UUID], $jobPositionTypeIds: [UUID]) {
    averageSeniority(
      argDepartmentIds: $departmentIds
      argJobPositionTypeIds: $jobPositionTypeIds
    )
  }
`)

export const DASHBOARD_VIEW_COUNT = graphql(`
  query dashboardViewCount {
    dashboardViews(filter: { active: { equalTo: true } }) {
      totalCount
    }
  }
`)

export const DASHBOARD_CONFIG = graphql(`
  query dashboardConfig($id: UUID!) {
    dashboardConfigByCompanyId(companyId: $id) {
      companyId
      pageTitle
      localizedPageTitle
    }
  }
`)

export const EXPORT_DASHBOARD_CARD_TO_EXCEL = graphql(`
  query exportDashboardCardToExcel(
    $dashboardCardId: UUID!
    $startDate: Date
    $endDate: Date
  ) {
    exportDashboardCardToExcel(
      input: {
        dashboardCardId: $dashboardCardId
        startDate: $startDate
        endDate: $endDate
      }
    ) {
      base64
    }
  }
`)

export const DASHBOARD_CARD_CHART = graphql(`
  query dashboardCardChart(
    $dashboardCardId: UUID!
    $dashboardCardStatisticId: UUID
    $startDate: Date
    $endDate: Date
  ) {
    dashboardCardChart(
      input: {
        dashboardCardId: $dashboardCardId
        dashboardCardStatisticId: $dashboardCardStatisticId
        startDate: $startDate
        endDate: $endDate
      }
    ) {
      data
    }
  }
`)
